import './styles.css'

import React from 'react'

import SetPlaceholder from '../../set_placeholder'

export default class JobTitle extends React.Component {
  render () {
    const { app, node } = this.props
    const data = node.data || {}
    return (
      <div
        onClick={ev =>
          app.toggleFloater(ev.target, 'text-field-picker', {
            field: 'data.job_title',
            nodeId: node.id
          })
        }
      >
        {data.job_title && <div className='actual-data'>{data.job_title}</div>}
        {!data.job_title && <SetPlaceholder />}
      </div>
    )
  }
}
